import axios, { AxiosError } from 'axios';

import { apiBaseUrl } from '@/api/base-url';
import { clearToken, readToken } from '@/auth/token-storage';

export const api = axios.create({ baseURL: apiBaseUrl });

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});

// No refresh endpoint: a 401 is terminal for every call except the auth bootstrap.
api.interceptors.response.use(undefined, async (error: unknown) => {
  if (
    error instanceof AxiosError &&
    error.response?.status === 401 &&
    !error.config?.url?.endsWith('/auth/me')
  ) {
    clearToken();
    window.location.assign('/login?error=session_expired');
  }
  return Promise.reject(error);
});
